<template>
  <div class="relative h-[1.5em] overflow-hidden">
    <div v-for="(item, i) in items" :key="i" class="absolute inset-0 flex items-center transition-opacity duration-500"
      :class="i === index ? 'opacity-100' : 'opacity-0'">
      {{ item }}
    </div>
  </div>
</template>
<script setup lang='ts'>
  import { onBeforeUnmount, onMounted, ref } from 'vue';

  const { items, interval = 1500 } = defineProps<{ items: string[], interval?: number }>()

  const index = ref(0)
  let timer: any;

  onMounted(() => {
    timer = setInterval(() => {
      index.value = (index.value + 1) % items.length
    }, interval)
  })

  onBeforeUnmount(() => clearInterval(timer))
</script>
